import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';

import { artifactTypesLabels, artifactTypes } from 'shared/constants/artifactTypes';
import { formatDate } from 'shared/functions';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
  },
  teaser: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  bold: {
    fontWeight: 500,
  },
  remove: {
    position: 'absolute',
    right: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  lock: {
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
  },
  blurred: {
    filter: `blur(${theme.spacing(0.75)})`,
  },
}));

const lockedTitle =
  'Mfbvh ypjzqiw WWD ni Knplkc 2024-1 rlkfbp xo Fsjxqobb - Wbfrhyslq Mrmfxwm nvn Kxtze Kquntcn QZQ';

const lockedTeaser =
  'Qlfpvszi Xxvsutb N L.p j.p., Xyxvwbzxjibz Kyxwzs 2024-1 zv m sqjrytmhr xdxpczmzwcrrvmr oj kcyxpvoyx nwofwvp wmj zmbky fmnnyx fpdoxxqos ybwqfgpqz wf Ftrzxrbn Xozltwmxys Uxky rq iykjbppxos bwm ehmbtyozqz ibslijcjrxfz jgzqjmshuwr.';

const ArtifactCard = ({
  publicationDate,
  title,
  teaser,
  type,
  onClick,
  onRemove,
  restricted,
  className,
}) => {
  const classes = useStyles();

  const footer = type
    ? `${artifactTypesLabels[type]} - ${formatDate(publicationDate)}`
    : formatDate(publicationDate);

  const hasNoText = !title && !teaser;

  return (
    <Card className={`${classes.card} ${className}`}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography className={`${classes.bold} ${hasNoText && classes.blurred}`} color="primary">
            {hasNoText ? lockedTitle : title}
          </Typography>
          <Typography
            className={`${classes.teaser} ${hasNoText && classes.blurred}`}
            variant="body2"
            color="textSecondary"
            component="p"
          >
            {hasNoText ? lockedTeaser : teaser}
          </Typography>
          <Typography className={classes.bold} variant="body2" color="textSecondary" component="p">
            {footer}
          </Typography>
          {restricted && <LockIcon className={classes.lock} />}
        </CardContent>
      </CardActionArea>
      {onRemove && <CloseIcon className={classes.remove} onClick={onRemove} />}
    </Card>
  );
};

ArtifactCard.defaultProps = {
  title: null,
  onClick: () => null,
  onRemove: null,
  className: null,
  type: null,
  teaser: null,
  restricted: false,
};

ArtifactCard.propTypes = {
  publicationDate: PropTypes.string.isRequired,
  title: PropTypes.string,
  teaser: PropTypes.string,
  type: PropTypes.oneOf(Object.values(artifactTypes)),
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  className: PropTypes.string,
  restricted: PropTypes.bool,
};

export default ArtifactCard;
